module.exports = __webpack_public_path__ + "img/contact15.7edd2e26.png";